import { render, staticRenderFns } from "./MenuSub.vue?vue&type=template&id=61538cd4&scoped=true"
import script from "./MenuSub.vue?vue&type=script&lang=js"
export * from "./MenuSub.vue?vue&type=script&lang=js"
import style0 from "./MenuSub.vue?vue&type=style&index=0&id=61538cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61538cd4",
  null
  
)

export default component.exports